import flashMessages from 'common/reducers/flashMessages';

import * as actions from './actions';
import {
  getOrderLineItemQuantityDiff,
  savedItemWithSku,
  getShippingCost,
} from './selectors';

import {
  getState as getSideNavState,
  toggleButtonVisibility as toggleSideNavButtonVisibility,
  toggleVisibility as toggleSideNavVisibility,
} from 'apps/application/header';

export default function(prevState, action) {
  const lineItemPendingWithSku = sku => {
    return state.lineItemsPending.find(item => item.sku === sku);
  };

  const state = {
    ...prevState,
    flashMessages: flashMessages(prevState.flashMessages, action),
  };

  const hamburgerMenu = document.getElementsByClassName(
    'header__hamburger-menu'
  )[0];

  switch (action.type) {
    case actions.SHOW_ADD_TO_CART_MESSAGE:
      return {
        ...state,
        addToCartSuccessQuantity: action.quantity,
      };
    case actions.HIDE_ADD_TO_CART_MESSAGE:
      return {
        ...state,
        addToCartSuccessQuantity: null,
      };
    case actions.CHANGE_COLLECTION_QUANTITY:
      const variants = action.collection.variants;
      const collectionId = action.collection.id;
      const collectionName = action.collection.name;
      const collectionQuantity = action.quantity;
      const lineItemsPendingInState = state.lineItemsPending.slice();
      const collectionsPending = state.collectionsPending.slice();
      const collectionHasQuantity = collectionQuantity > 0;
      const collectionItem = collectionsPending.find(
        item => item.id === collectionId
      );

      if (collectionItem && collectionHasQuantity) {
        collectionItem.quantity = collectionQuantity;
      } else if (collectionItem && !collectionHasQuantity) {
        collectionsPending = [];
      } else {
        collectionsPending.push({
          id: collectionId,
          name: collectionName,
          quantity: collectionQuantity,
        });
      }

      variants.forEach(variant => {
        let lineItem = savedItemWithSku(variant.sku, state);
        let lineItemPending = lineItemPendingWithSku(variant.sku);

        if (!lineItemPending) {
          lineItemPending = { sku: variant.sku, quantity: 0 };
          lineItemsPendingInState.push(lineItemPending);
        }

        if (lineItem) {
          lineItemPending.quantity =
            lineItem.quantity + variant.quantity * collectionQuantity;
        } else {
          lineItemPending.quantity = variant.quantity * collectionQuantity;
        }
      });

      return {
        ...state,
        lineItemsPending: lineItemsPendingInState,
        collectionsPending,
      };
    case actions.CHANGE_VARIANT_QUANTITY:
      const { quantity, variant } = action;
      const lineItemsPending = state.lineItemsPending.slice();
      let lineItem = lineItemPendingWithSku(variant.sku);
      if (!lineItem) {
        lineItem = { sku: variant.sku };
        lineItemsPending.push(lineItem);
      }

      lineItem.quantity = quantity;

      state.lineItemsPending = lineItemsPending;

      return {
        ...state,
        lineItemsPending,
      };

    case actions.COLLECTION_ADDED:
      return {
        ...state,
        collectionsPending: [],
        isCollectionSavingRequest: false,
      };

    case actions.UPDATE_COLLECTION_SAVING_REQUEST:
      return {
        ...state,
        isCollectionSavingRequest: true,
      };

    case actions.SAVE_CART_REQUEST:
      return {
        ...state,
        isSaving: true,
        variantsSaving: action.lineItems,
      };

    case actions.SAVE_CART_SUCCESS:
      const { order } = action;
      const previousOrder = { ...state.currentOrder };
      lineItemsPending = [];

      const newState = {
        ...state,
        currentOrder: order,
        isSaving: false,
        pendingQuantity: 0,
        pendingPrice: 0,
        lineItemsPending,
        lineItemsProcessing: [],
        hasSavedCart: true,
        variantsSaving: [],
      };

      newState.shippingCost = getShippingCost(newState);

      const orderLineItemQuantityDiff = getOrderLineItemQuantityDiff(
        previousOrder,
        order,
        newState
      );

      state.lineItemsPending.forEach(lineItem => {
        const pendingItem = orderLineItemQuantityDiff.find(
          item => item.sku === lineItem.sku
        );
        if (!pendingItem || pendingItem.quantityDiff === 0) {
          lineItemsPending.push(lineItem);
        }
      });

      return newState;

    case actions.SAVE_CART_ERROR:
      return {
        ...state,
        pendingQuantity: 0,
        pendingPrice: 0,
        isSaving: false,
        lineItemsPending: [],
        lineItemsProcessing: [],
        variantsSaving: [],
        isCollectionSavingRequest: false,
      };

    case actions.TOGGLE_CART_VISIBILITY:
      toggleSideNavButtonVisibility(hamburgerMenu);

      const isOpen = !state.isOpen;
      const currentOrder = { ...state.currentOrder };

      if (isOpen) {
        state.currentOrderAtCartOpen = currentOrder;
        const sideNavIsOpen = getSideNavState();
        if (sideNavIsOpen) {
          toggleSideNavVisibility();
        }
      } else {
        state.currentOrderAtCartOpen = null;
        currentOrder.line_items = currentOrder.line_items.filter(item => {
          return item.quantity !== 0;
        });
      }

      return {
        ...state,
        currentOrder,
        isOpen,
        learnMoreIsOpen: false,
      };

    case actions.CHANGE_LINE_ITEM_PROCESSING_QUANTITY: {
      const lineItemsProcessing = state.lineItemsProcessing.slice();
      const { lineItem, quantity } = action;
      const lineItemExisting = lineItemsProcessing.find(
        item => item.sku === lineItem.sku
      );
      if (lineItemExisting) {
        lineItemExisting.quantity = quantity;
      } else {
        lineItemsProcessing.push({ sku: lineItem.sku, quantity });
      }

      return {
        ...state,
        lineItemsProcessing,
      };
    }

    case actions.CHANGE_LEARN_MORE_MODAL_VISIBILITY: {
      return {
        ...state,
        learnMoreIsOpen: action.value,
      };
    }

    case actions.CHANGE_COMMITMENT_DETAILS_MODAL_VISIBILITY: {
      return {
        ...state,
        commitmentDetailsIsOpen: action.value,
      };
    }

    case actions.CHANGE_NICOTINE_STRENGTH_DETAILS_MODAL_VISIBILITY: {
      return {
        ...state,
        nicotineStrengthDetailsIsOpen: action.value,
      };
    }

    case actions.SIDEBAR_FOCUS_CHANGED: {
      return {
        ...state,
        sidebarIsFocused: action.isFocused,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/reducer.js